const MOIS_FR = [
  "janvier",
  "février",
  "mars",
  "avril",
  "mai",
  "juin",
  "juillet",
  "août",
  "septembre",
  "octobre",
  "novembre",
  "décembre",
];

export function isoDate(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
    date.getDate()
  ).padStart(2, "0")}`;
}

export function startOfDay(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function todayISO(): string {
  return isoDate(new Date());
}

/** Clé de période au format `YYYY-MM`. Retourne une chaîne vide si la date est invalide. */
export function toMonthKey(date: Date): string {
  if (Number.isNaN(date.getTime())) return "";
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
}

export function monthLabel(key: string): string {
  const [year, month] = key.split("-").map(Number);
  if (!year || !month || !MOIS_FR[month - 1]) return key;
  const label = `${MOIS_FR[month - 1]} ${year}`;
  return label.charAt(0).toUpperCase() + label.slice(1);
}

/** Liste des périodes `YYYY-MM` entre deux clés incluses (ordre chronologique). */
export function periodRange(startKey: string, endKey: string, maxMonths = 120): string[] {
  const [sy, sm] = startKey.split("-").map(Number);
  const [ey, em] = endKey.split("-").map(Number);
  if (!sy || !sm || !ey || !em) return [];
  const result: string[] = [];
  let year = sy;
  let month = sm;
  while ((year < ey || (year === ey && month <= em)) && result.length < maxMonths) {
    result.push(`${year}-${String(month).padStart(2, "0")}`);
    month += 1;
    if (month > 12) {
      month = 1;
      year += 1;
    }
  }
  return result;
}

/** Date d'échéance (`YYYY-MM-DD`) pour une période et un jour du mois. */
export function echeanceISO(periode: string, jour: number): string {
  const [year, month] = periode.split("-").map(Number);
  if (!year || !month) return "";
  const lastDay = new Date(year, month, 0).getDate();
  const day = Math.min(Math.max(jour || 1, 1), lastDay);
  return isoDate(new Date(year, month - 1, day));
}

export function daysBetween(fromISO: string, toISO: string): number {
  const from = new Date(`${fromISO}T00:00:00`).getTime();
  const to = new Date(`${toISO}T00:00:00`).getTime();
  if (Number.isNaN(from) || Number.isNaN(to)) return 0;
  return Math.round((to - from) / 86_400_000);
}

export function addMonthsKey(key: string, count: number): string {
  const [year, month] = key.split("-").map(Number);
  if (!year || !month) return "";
  const date = new Date(year, month - 1 + count, 1);
  return toMonthKey(date);
}

/** Périodes couvertes par un contrat : de sa date de début jusqu'à sa fin (ou le mois suivant). */
export function contratPeriodKeys(dateDebut: string, dateFin?: string, maxMonths = 120): string[] {
  if (!dateDebut) return [];
  const startKey = toMonthKey(new Date(dateDebut));
  if (!startKey) return [];
  const now = new Date();
  const nextKey = toMonthKey(new Date(now.getFullYear(), now.getMonth() + 1, 1));
  const finKey = dateFin ? toMonthKey(new Date(dateFin)) : "";
  const endKey = finKey && finKey >= startKey ? finKey : nextKey;
  return periodRange(startKey, endKey, maxMonths);
}